<template>
  <div>
    <RecipeForm :recipe="recipe"></RecipeForm>
  </div>
</template>

<script>
import RecipeForm from "./RecipeForm.vue";
//import RecipeEdit from "./RecipeEdit.vue";

export default {
    data() {
        return {
            id: ""
        };
    },

    created() {
        this.id = this.$route.params.id;
    },

    components: {
        RecipeForm: RecipeForm /*,
        recipeEdit: RecipeEdit*/
    },

    computed: {
        recipe() {
            const id = this.id;
            console.log("id", id);
            return this.$store.getters.recipeById(id);
        }
    },

    methods: {}
};
</script>

















<!--<template>
  <div>
    <p>
      <label for="recipe-name">Recipe Name
        <br>
        <input
          id="recipe-name"
          name="recipe-name"
          ref="recipeName"
          type="text"
          :value="name"
          class="input--h1"
        >
      </label>
    </p>
    <p>
      <label for="recipe-prepTime">Prep Time
        <br>
        <input
          id="recipe-prepTime"
          name="recipe-prepTime"
          type="number"
          :value="prepTime"
          class="input--text"
        >
      </label>
    </p>
    <p>
      <label for="recipe-cookTime">Cook Time
        <br>
        <input
          id="recipe-cookTime"
          name="recipe-cookTime"
          type="number"
          :value="cookTime"
          class="input--text"
        >
      </label>
    </p>
    <p>{{ getIngredientsLength(recipe.sectionIds) }} Ingredients</p>
    <p>
      <label for="recipe-servings">Servings
        <br>
        <input
          id="recipe-servings"
          name="recipe-servings"
          type="number"
          :value="recipe.servings"
          class="input--text"
        >
      </label>
    </p>
    <div class="ingredients--edit">
      <h2>Ingredients</h2>
      <br>
      <div class="ingredient--edit" v-for="(section, index) in recipeSections">
        <p>
          <label :for="`ingredientSectionTitle${index}`">Section Title</label>
          <input
            type="text"
            class="no-margin"
            :name="`ingredientSectionTitle${index}`"
            :value="section.ingredientTitle"
          >
        </p>
        <div v-for="(ingredient, index2) in section.ingredients">
          <p>Ingredient {{ index2 + 1 }}</p>
          <div class="input--ingredientAmount">
            <label :for="`ingredientAmount${index2}`">Amount</label>
            <input
              type="text"
              class="input--text"
              :name="`ingredientAmount${index2}`"
              :value="ingredients[ingredient].amount"
            >
          </div>
          <div class="input--ingredientName">
            <label :for="`ingredientName${index2}`">Name</label>
            <input
              type="text"
              class="input--text"
              :name="`ingredientName${index2}`"
              :value="ingredients[ingredient].name"
            >
          </div>
          <div
            class="input--ingredientNote"
            :class="ingredients[ingredient].note === '' ? 'input--ingredientNote-none' : ''"
          >
            <label :for="`ingredientNote${index2}`">Note</label>
            <textarea
              class="input--text"
              :name="`ingredientNote${index2}`"
              :value="ingredients[ingredient].note"
            ></textarea>
          </div>
        </div>
        <button
          class="button button--addNew"
          @click="addNewIngredient(index)"
        >Add Another Ingredient</button>
      </div>
      <button class="button button--addNew" @click="addNewIngredientSection()">Add Another Section</button>
    </div>

    <div class="directions--edit">
      <h2>Directions</h2>
      <br>
      <div class="direction--edit" v-for="(section, index) in recipeSections">
        <p>
          <label :for="`directionSectionTitle${index}`">Section Title</label>
          <input
            type="text"
            class="input--text"
            :name="`directionSectionTitle${index}`"
            :value="section.directionTitle"
          >
        </p>

        <p v-if="section.sectionNote !== ''">
          <label for="`directionSectionNote${note}`">Note</label>
          <br>
          <textarea :value="directionSection.note" class="input--text"></textarea>
        </p>
        <div v-for="(direction, index2) in section.directions">
          <p>Direction {{ index2 + 1}}</p>
          <div class="input--direction">
            <label :for="`directionName${index2}`">Direction</label>
            <textarea
              class="input--text"
              :name="`directionName${index2}`"
              :value="directions[direction].direction"
            ></textarea>
          </div>
          <div class="input--ingredientNote">
            <label :for="`directionNote${index2}`">Note</label>
            <textarea class="input--text" :name="`directionNote${index2}`" :value="direction.note"></textarea>
          </div>
        </div>
        <button class="button button--addNew" @click="addNewDirection(index)">Add Another Direction</button>
      </div>
      <button class="button button--addNew" @click="addNewDirectionSection()">Add Another Section</button>
    </div>
    <button class="button" @click="saveRecipe">Save</button>
    <button class="button" @click="cancelEdit">Cancel</button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            id: 0,
            urlId: "",
            name: "",
            prepTime: 0,
            cookTime: 0,
            servings: 0,
            sectionIds: [],
            details: [],
            origDate: new Date().now,
            ingredientsLength: 0
        };
    },

    created() {
        this.urlId = this.$route.params.id;
        this.name = this.recipe.name;
        this.prepTime = this.recipe.prepTime;
        this.cookTime = this.recipe.cookTime;
        this.servings = this.recipe.servings;

        //this.recipeNewIngredients = this.recipe.ingredients;
        //this.directions = this.recipe.directions;
    },

    data() {
        return {
            recipeName: "",
            recipePrepTime: 0,
            recipeCookTime: 0,
            recipeServings: 0,
            recipeIngredients: {
                "0": {
                    title: "",
                    ingredients: [{ amount: "", name: "", note: "" }]
                }
            },
            recipeDirections: [
                {
                    title: "",
                    note: "",
                    directions: [{ id: 0, direction: "", note: "" }]
                }
            ]
        };
    },

    computed: {
        ...mapGetters(["recipes", "sections", "ingredients", "directions"]),
        recipe() {
            const id = this.urlId;
            if (!id) {
                this.createNewRecipe();
                return;
            }
            return this.$store.getters.recipeById(id);
        },
        recipeSections() {
            let sectionIds = this.recipe.sectionIds; // [ 0, 1 ]
            let sectionArray = [];

            sectionIds.forEach(section => {
                console.log(section);
                sectionArray.push(this.sections[section]);
            });

            return sectionArray;
        }
    },

    methods: {
        ...mapActions(["addNewRecipe", "updateRecipe"]),
        getIngredientsLength(sectionNumbers) {
            let ingredientsLength = 0;

            sectionNumbers.forEach(section => {
                ingredientsLength += this.sections[section].ingredients.length;
            });

            return ingredientsLength;
        },
        saveRecipe() {
            // save recipe here, then navigate to recipe page
            //this.toggleEditStatus();
            this.updateRecipe(this.recipe);
            this.recipe.urlId = encodeURIComponent(
                this.$refs["recipeName"].value
            );
            /*this.recipe.name = this.$refs["recipeName"].value;
            this.recipe.prepTime = this.$refs["recipePrepTime"].value;
            this.recipe.cookTime = this.$refs["recipeCookTime"].value;
            this.recipe.servings = this.$refs["recipeServings"].value;*/

            this.$router.push({
                name: "recipe",
                params: { id: this.urlId }
            });
        },
        cancelEdit() {
            if (confirm("Do you want to cancel your changes?")) {
                //this.toggleEditStatus();
                this.$router.replace({
                    name: "recipe",
                    params: { id: this.urlId }
                });
            }
        },
        addNewIngredientSection() {
            const id = this.ingredients.length;
            console.log(this.ingredients);
            //this.ingredients[id] = id: { title: "", ingredients: [] };
            this.addNewIngredient(this.ingredients.length - 1);
        },
        addNewIngredient(index) {
            /*this.ingredients[index].ingredients.push({
								amount: "",
								name: "",
								note: ""
						});*/
        },
        addNewDirectionSection() {
            this.directions.push({ title: "", note: "", directions: [] });
            this.addNewDirection(this.directions.length - 1, 0);
        },
        addNewDirection(index, id) {
            this.directions[index].directions.push({
                id: id,
                direction: "",
                note: ""
            });
        }
    }
};
</script>-->
